/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ first_monthly_price: NonNullable<unknown>, monthly_price: NonNullable<unknown> }} Starter_Challenge_Paywall_Footer_MonthlyInputs */

const en_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_monthly_price} at first month, then ${i?.monthly_price}/month. Cancel anytime.`)
};

const ar_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_monthly_price} للشهر الأول، ثم ${i?.monthly_price}/شهر. إلغاء في أي وقت.`)
};

const de_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_monthly_price} im ersten Monat, danach ${i?.monthly_price}/Monat. Jederzeit kündbar.`)
};

const es_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_monthly_price} el primer mes, luego ${i?.monthly_price}/mes. Cancela cuando quieras.`)
};

const fr_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_monthly_price} le premier mois, puis ${i?.monthly_price}/mois. Annulez à tout moment.`)
};

const it_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_monthly_price} per il primo mese, poi ${i?.monthly_price}/mese. Annulla in qualsiasi momento.`)
};

const ja_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`初月 ${i?.first_monthly_price}、以降 ${i?.monthly_price}/月。いつでもキャンセル可能。`)
};

const ko_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`첫 달 ${i?.first_monthly_price}, 이후 ${i?.monthly_price}/월. 언제든지 취소 가능.`)
};

const pt_br_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_monthly_price} no primeiro mês, depois ${i?.monthly_price}/mês. Cancele quando quiser.`)
};

const ru_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_monthly_price} в первый месяц, затем ${i?.monthly_price}/месяц. Отмена в любое время.`)
};

const th_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_monthly_price} สำหรับเดือนแรก จากนั้น ${i?.monthly_price}/เดือน ยกเลิกได้ทุกเมื่อ`)
};

const tr_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`İlk ay ${i?.first_monthly_price}, ardından ${i?.monthly_price}/ay. İstediğiniz zaman iptal edin.`)
};

const zh_cn_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_monthly_price} 首月，续订 ${i?.monthly_price}/月。随时可取消。`)
};

const zh_tw_starter_challenge_paywall_footer_monthly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_monthly_price} 首月，續訂 ${i?.monthly_price}/月。隨時可取消。`)
};

/**
* | output |
* | --- |
* | "{first_monthly_price} at first month, then {monthly_price}/month. Cancel anytime." |
*
* @param {Starter_Challenge_Paywall_Footer_MonthlyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_paywall_footer_monthly = /** @type {((inputs: Starter_Challenge_Paywall_Footer_MonthlyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Paywall_Footer_MonthlyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_paywall_footer_monthly(inputs)
	if (locale === "ar") return ar_starter_challenge_paywall_footer_monthly(inputs)
	if (locale === "de") return de_starter_challenge_paywall_footer_monthly(inputs)
	if (locale === "es") return es_starter_challenge_paywall_footer_monthly(inputs)
	if (locale === "fr") return fr_starter_challenge_paywall_footer_monthly(inputs)
	if (locale === "it") return it_starter_challenge_paywall_footer_monthly(inputs)
	if (locale === "ja") return ja_starter_challenge_paywall_footer_monthly(inputs)
	if (locale === "ko") return ko_starter_challenge_paywall_footer_monthly(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_paywall_footer_monthly(inputs)
	if (locale === "ru") return ru_starter_challenge_paywall_footer_monthly(inputs)
	if (locale === "th") return th_starter_challenge_paywall_footer_monthly(inputs)
	if (locale === "tr") return tr_starter_challenge_paywall_footer_monthly(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_paywall_footer_monthly(inputs)
	return zh_tw_starter_challenge_paywall_footer_monthly(inputs)
});